// src/components/fraud/BlacklistFilterBar.js
// Search + filter chips + action buttons (Add Entry, Refresh).
// Matches the styling of FraudLogsFilter exactly.

import React from 'react';
import { Row, Col, InputGroup, Form } from 'react-bootstrap';

// ─── Shared styles (copied from FraudLogsFilter) ─────────────────────────────
const inputStyle = {
  backgroundColor: 'var(--bg-primary)',
  color: 'var(--text-primary)',
  border: '1px solid rgba(255,255,255,0.12)',
  borderRadius: 8,
  fontSize: 13,
};

const labelStyle = {
  fontSize: 10,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: 0.8,
  color: 'var(--text-secondary)',
  marginBottom: 4,
  display: 'block',
};

// ─── Filter chip ──────────────────────────────────────────────────────────────
const Chip = ({ label, active, onClick, color }) => (
  <button
    onClick={onClick}
    style={{
      background: active
        ? (color ? `${color}22` : 'rgba(217,255,31,0.12)')
        : 'rgba(255,255,255,0.04)',
      border: `1px solid ${active ? (color || 'var(--accent-lime)') : 'rgba(255,255,255,0.10)'}`,
      borderRadius: 20,
      color: active ? (color || 'var(--accent-lime)') : 'var(--text-secondary)',
      fontSize: 11,
      fontWeight: active ? 700 : 500,
      padding: '4px 12px',
      cursor: 'pointer',
      transition: 'all 0.15s ease',
      whiteSpace: 'nowrap',
    }}
  >
    {label}
  </button>
);

// ─── Main Component ───────────────────────────────────────────────────────────
const BlacklistFilterBar = ({
  search, onSearchChange,
  statusFilter, onStatusChange,
  typeFilter, onTypeChange,
  onAdd, onRefresh,
  loading,
}) => (
  <div
    id="blacklist-filter-bar"
    className="theme-card rounded-3 p-3 mb-4"
    style={{ borderColor: 'rgba(255,255,255,0.08)' }}
  >
    <Row className="g-2 align-items-end">
      {/* ── Search ── */}
      <Col xs={12} md={6} lg={4}>
        <label style={labelStyle}>Search</label>
        <InputGroup>
          <Form.Control
            id="blacklist-search-input"
            type="text"
            placeholder="UID, email, phone, IP, reason…"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            style={inputStyle}
          />
          {search && (
            <button
              onClick={() => onSearchChange('')}
              style={{
                background: 'var(--bg-primary)',
                border: '1px solid rgba(255,255,255,0.12)',
                borderLeft: 'none',
                borderRadius: '0 8px 8px 0',
                color: 'var(--text-secondary)',
                padding: '0 10px',
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              ×
            </button>
          )}
        </InputGroup>
      </Col>

      {/* ── Add + Refresh ── */}
      <Col xs={12} md="auto" className="ms-md-auto d-flex gap-2 align-items-end">
        <button
          id="blacklist-refresh-btn"
          onClick={onRefresh}
          disabled={loading}
          title="Refresh"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 8,
            color: 'var(--text-secondary)',
            padding: '7px 14px',
            cursor: loading ? 'default' : 'pointer',
            fontSize: 14,
          }}
        >
          {loading ? <span className="admin-loader-sm" /> : '↻'}
        </button>
        <button
          id="blacklist-add-btn"
          onClick={onAdd}
          style={{
            background: 'var(--accent-lime)',
            border: 'none',
            borderRadius: 8,
            color: '#050014',
            fontWeight: 700,
            fontSize: 13,
            padding: '7px 18px',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          + Add Entry
        </button>
      </Col>
    </Row>

    {/* ── Filter chips ── */}
    <div className="d-flex flex-wrap gap-2 mt-3">
      {/* Status */}
      <Chip label="All"      active={statusFilter === 'all'}      onClick={() => onStatusChange('all')} />
      <Chip label="Active"   active={statusFilter === 'active'}   onClick={() => onStatusChange('active')}   color="#22C55E" />
      <Chip label="Disabled" active={statusFilter === 'disabled'} onClick={() => onStatusChange('disabled')} color="#A6A3B8" />

      <span style={{ width: 1, background: 'var(--divider)', margin: '0 4px' }} />

      {/* Type */}
      <Chip label="UID"   active={typeFilter === 'uid'}   onClick={() => onTypeChange(typeFilter === 'uid'   ? 'all' : 'uid')}   color="#8B5CF6" />
      <Chip label="Email" active={typeFilter === 'email'} onClick={() => onTypeChange(typeFilter === 'email' ? 'all' : 'email')} color="#3B82F6" />
      <Chip label="Phone" active={typeFilter === 'phone'} onClick={() => onTypeChange(typeFilter === 'phone' ? 'all' : 'phone')} color="#22C55E" />
      <Chip label="IP"    active={typeFilter === 'ip'}    onClick={() => onTypeChange(typeFilter === 'ip'    ? 'all' : 'ip')}    color="#F59E0B" />
    </div>
  </div>
);

export default BlacklistFilterBar;
